import './style.scss';
import { useHistory } from 'react-router-dom';
import {
  IProjectInfo,
  IProjectDocInfoMenu,
  IProjectDocInfoTags,
  IProjectDocInfo,
  IContentNav,
  IDocContentLoadInfo,
} from '../../../model/api-modules/document';
import { QuickAccess } from '../quick-access';
import { MostViewedDocumentation } from '../most-viewed-documentation';
import { DocumentSwitch } from '../document-switch';
import { DocumentNav } from '../document-nav';
import moment from 'moment';
import { getDocumentParams } from '../utils';
import { RightCatalogue } from '../right-catalogue';
import { LanguageType, AppEnvType } from '../../../model';
import { LanguageType as langType } from '../../../lib';
import { ServicesManualContent } from '../services-manual-content';
import { jumpToLogin } from '../../lib';
import noPer from '../../../assets/svg/no-per.svg';
import getFormatMessage from '../../../locales/get-format-message';
import { useSelector } from 'react-redux';
import { IRootState } from '../../../store/reducers';

interface IProps {
  readonly currentProject: IProjectInfo;
  readonly currentDocument: IProjectDocInfoMenu | undefined;
  readonly activeDocuments: ReadonlyArray<IProjectDocInfoMenu> | undefined;
  readonly tagIsExists: boolean;
  readonly inductionTags: ReadonlyArray<IProjectDocInfoTags> | undefined;
  readonly hotDocument: ReadonlyArray<IProjectDocInfoMenu> | undefined;
  readonly projectContentLoadInfoRef: React.MutableRefObject<IDocContentLoadInfo>;
  readonly docContentLoadInfoRef: React.MutableRefObject<IDocContentLoadInfo>;
  readonly projectDocInfo: IProjectDocInfo | undefined;
  readonly contentNav: ReadonlyArray<IContentNav> | undefined;
  readonly activeId: string;
  readonly setActiveId: (value: string) => void;
  readonly setSelectActive: (value: ReadonlyArray<number>) => void;
  readonly lang: LanguageType | null;
  readonly isDocPublicRoute: boolean;
}

export const DocumentContent = (props: IProps) => {
  const history = useHistory();
  const lang = props.lang === LanguageType.ZH ? langType.zh_CN : langType.en_US;
  const { projectId, docId } = getDocumentParams();
  const isProd = process.env.REACT_APP_ENV === AppEnvType.Production;
  // const testShow =
  //   !isProd &&
  //   ((projectId === '38' && docId === '1055') ||
  //     (projectId === '39' && docId === '1012'));
  const testShow =
    !isProd &&
    ((projectId === '35' && docId === '1103') ||
      (projectId === '36' && docId === '1006'));
  const prodShow =
    isProd &&
    ((projectId === '35' && docId === '1103') ||
      (projectId === '36' && docId === '1006'));
  const isShowServices = testShow || prodShow;
  const userInfo = useSelector((state: IRootState) => state.common.userInfo);

  const joinPath = (projectId: string | number, docId?: string | number) => {
    if (!projectId) return;
    const url = props.isDocPublicRoute ? '/doc-public' : '/doc';
    if (docId) {
      history.push(`${url}/detail/${projectId}/${docId}`);
      return;
    }
    history.push(`${url}/detail/${projectId}`);
  };

  const formatDate = (date: string) => {
    return moment(date).format('YYYY-MM-DD HH:mm:ss');
  };

  const isShowContent = () => {
    // visibility: 1 可免登录查看
    if (props.currentDocument?.visibility === 1 || userInfo) {
      return true;
    }
    return false;
  };

  return (
    <div className="c-document-main-content" id="content">
      {isShowContent() && (
        <DocumentNav
          currentProject={props.currentProject}
          activeDocuments={props.activeDocuments}
          joinPath={joinPath}
        />
      )}
      <div className="c-container" id="containerContent">
        {props.currentProject && projectId && !docId && (
          <div>
            <p className="c-title">{props.currentProject.name}</p>
            <div className="c-box">
              <div className="c-box-title">
                <p>
                  <span>
                    {props.lang === LanguageType.ZH
                      ? '更新时间:'
                      : 'Update time:'}
                  </span>
                  <span style={{ marginLeft: '8px' }}>
                    {formatDate(props.currentProject.updated_at || '')}
                  </span>
                </p>
              </div>
            </div>
            <div className="c-markdown-wapper">
              <div className="markdown-content">
                {props.projectContentLoadInfoRef.current.isShowContentDom && (
                  <div
                    className="c-markdown markdown"
                    id="projectContentBox"
                  ></div>
                )}
                {props.tagIsExists && (
                  <QuickAccess
                    lang={props.lang}
                    inductionTags={props.inductionTags}
                    joinPath={joinPath}
                    setSelectActive={props.setSelectActive}
                  />
                )}
                {props.hotDocument && props.hotDocument?.length > 0 && (
                  <MostViewedDocumentation
                    lang={props.lang}
                    hotDocument={props.hotDocument}
                    joinPath={joinPath}
                    setSelectActive={props.setSelectActive}
                  />
                )}
              </div>
            </div>
          </div>
        )}
        {projectId &&
          docId &&
          props.currentProject &&
          props.currentDocument &&
          isShowContent() && (
            <div>
              <p className="c-title">{props.currentDocument.name}</p>
              <div className="c-box export-box">
                <div className="c-box-title">
                  <p>
                    <span>
                      {props.lang === LanguageType.ZH
                        ? '更新时间:'
                        : 'Update time:'}
                    </span>
                    <span style={{ marginLeft: '8px' }}>
                      {formatDate(props.currentDocument.updated_at || '')}
                    </span>
                  </p>
                </div>
              </div>
              {projectId && docId && (
                <RightCatalogue
                  projectDocInfo={props.projectDocInfo}
                  contentNav={props.contentNav}
                  activeId={props.activeId}
                  setActiveId={props.setActiveId}
                  lang={props.lang}
                />
              )}
              {props.docContentLoadInfoRef.current.isShowContentDom && (
                <div className="c-markdown-wapper">
                  {isShowServices && (
                    <ServicesManualContent
                      isDocPublicRoute={props.isDocPublicRoute}
                      lang={props.lang}
                    />
                  )}
                  <div className="c-markdown markdown" id="docContentBox">
                    {/* <textarea style="display: none" v-model="document"> </textarea> */}
                  </div>
                </div>
              )}
              <DocumentSwitch
                currentDocument={props.currentDocument}
                projectDocInfo={props.projectDocInfo}
                joinPath={joinPath}
                setSelectActive={props.setSelectActive}
              />
            </div>
          )}
        {projectId &&
          docId &&
          props.currentProject &&
          props.currentDocument &&
          !isShowContent() && (
            <div className="document-content-no-per">
              <img src={noPer} className="no-per-img" />
              <div className="no-per-first">
                {getFormatMessage('content_no_per_first', {}, lang)}
              </div>
              <div className="no-per-second">
                <span>
                  {getFormatMessage('content_no_per_second_left', {}, lang)}
                </span>
                <span className="no-per-second-login" onClick={jumpToLogin}>
                  {getFormatMessage('content_no_per_second_login', {}, lang)}
                </span>
                <span>
                  {getFormatMessage('content_no_per_second_right', {}, lang)}
                </span>
              </div>
            </div>
          )}
      </div>
    </div>
  );
};
